import { AnimatedSpriteWrap } from "common/pixi/animatedSprite";
import { Sheets } from "common/sheets";
export class BackgroundPerson {
    constructor(pixiContext, sheets) {
        const textures = Sheets.animationTextures(sheets, "배경 인물");
        const rightSprite = new AnimatedSpriteWrap(pixiContext, textures);
        rightSprite.anchor.set(0.5, 0.5);
        const leftSprite = new AnimatedSpriteWrap(pixiContext, textures);
        leftSprite.anchor.set(0.5, 0.5);
        this.rightSprite = rightSprite;
        this.leftSprite = leftSprite;
        this.rightSprite.animationSpeed = 0.3;
        this.leftSprite.animationSpeed = 0.3;
        this.rightSprite.visible = false;
        this.leftSprite.visible = false;
    }
}
export const imageName = encodeURIComponent("배경 인물.png");
//# sourceMappingURL=backgroundPerson.js.map